<template>
    <div>
        <div class="main-button-bar">
            <el-row class="search-row">
                <el-select
                    v-model="typeArr"
                    clearable
                    multiple
                    collapse-tags
                    placeholder="交易类型"
                    class="search-item"
                >
                    <el-option v-for="item in types" :key="item" :label="item" :value="item"></el-option>
                </el-select>

                <el-input v-model="params.orderId" placeholder="订单号" class="search-item"></el-input>
            </el-row>
            <el-row class="search-row">
                <el-date-picker
                    type="date"
                    placeholder="交易时间（开始）"
                    v-model="params.bizDateStart"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>

                <el-date-picker
                    type="date"
                    placeholder="交易时间（截止）"
                    v-model="params.bizDateEnd"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>

                <el-button type="primary" size="small" @click="page(1)">搜索</el-button>
                <el-link class="search-link" type="primary" @click="showTotal">查看统计数据</el-link>
            </el-row>
        </div>

        <el-table
            :data="records"
            stripe
            style="width: 100%"
            :height="this.$tools.mainHeight() - 135"
            class="alibaba-order-table"
        >
            <el-table-column prop="bizDate" label="交易时间" width="160">
                <template slot-scope="order">{{ $tools.timestampToTime(order.row.bizDate)}}</template>
            </el-table-column>
            <el-table-column prop="orderId" label="订单号" width="200"></el-table-column>
            <el-table-column prop="account" label="交易账户" width="120"></el-table-column>
            <el-table-column prop="type" label="交易类型" width="100"></el-table-column>

            <el-table-column prop="amount" label="金额($)" width="150">
                <template slot-scope="order">{{ $tools.parsecost(order.row.amount, true)}}</template>
            </el-table-column>

            <el-table-column prop="closingBalance" label="余额($)" width="150">
                <template slot-scope="order">{{ $tools.parsecost(order.row.closingBalance, true)}}</template>
            </el-table-column>
        </el-table>

        <el-pagination
            small
            layout="total, prev, pager, next"
            :total="params.total"
            @current-change="page"
            :current-page.sync="params.current"
        ></el-pagination>

        <el-drawer
            :visible.sync="show"
            direction="rtl"
            :modal="false"
            :modal-append-to-body="false"
            size="800px"
            :withHeader="false"
            class="alibaba-bill-drawer"
        >
            <div :style="'height:' + (this.$tools.mainHeight() + 60) + 'px;overflow:auto;'">
                <el-card class="box-card" style="text-align: center">
                    <el-radio-group v-model="params.totalType" @change="showTotal">
                        <el-radio label="D">按日查看</el-radio>
                        <el-radio label="M">按月查看</el-radio>
                    </el-radio-group>
                </el-card>

                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>收款趋势</span>
                    </div>
                    <div id="amount"></div>
                </el-card>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import SnUserSearchInput from "../components/SnUserSearchInput.vue";
import { Chart } from "@antv/g2";
export default {
    components: { SnUserSearchInput, Chart },
    data() {
        return {
            shops: [],
            types: ["冻结", "放款&收款", "提现", "退款", "解冻", "扣款"],
            records: null,
            totalData: null,
            totalAmount: 0,
            params: {
                shopId: null,
                seller: null,
                totalType: "D",
            },
            typeArr: [],
            show: false,
            char: { amount: null },
        };
    },
    mounted() {
        this.getShops();
        this.page(1);
    },
    methods: {
        getShops() {
            let _this = this;

            _this.$http.post(
                ["alibaba/shop/all"],
                [
                    function (data) {
                        _this.shops = data;
                    },
                ],
                ".alibaba-buyer-table"
            );
        },
        page(current) {
            let _this = this;

            if (current) {
                _this.params.current = current;
            }

            _this.params.type = _this.typeArr.join(",");

            _this.$http.post(
                ["alibaba/bill/page", _this.params],
                [
                    function (data) {
                        _this.params.total = data.total;
                        _this.records = data.records;
                    },
                ],
                ".alibaba-order-table"
            );
        },
        showTotal() {
            let _this = this;

            _this.show = true;

            _this.$http.post(
                ["alibaba/bill/total", _this.params],
                [
                    function (data) {
                        for (var i in data) {
                            data[i].amount = _this.$tools.parsecost(
                                data[i].amount
                            );

                            _this.totalAmount += data[i].amount;
                        }

                        _this.totalData = data;
                        _this.render("amount", data, "date*amount", "type");
                    },
                ],
                ".alibaba-order-drawer"
            );
        },
        render(name, data, position, type, action) {
            let _this = this;

            if (!this.char[name]) {
                this.char[name] = new Chart({
                    container: name,
                    autoFit: true,
                    height: 250,
                });

                this.char[name]
                    .interval()
                    .position(position)
                    .adjust([
                        {
                            type: "dodge",
                            marginRatio: 0,
                        },
                    ])
                    .color(type).adjust(["stack"]);;
            }

            this.char[name].data(data);
            this.char[name].render();
        },
    },
};
</script>

<style lang="scss" scoped>
</style>